module.exports = __webpack_public_path__ + "media/img/decorations/history-year-after-7d5357d0afc547402d76ad924213aa56.svg";